/**
 * 用户信息
 */
import {
NOW_THEME_COLOR, NOW_UP_COLOR, NOW_LANG, ACTIVE_PAGE, ACTIVESYMBOL,
} from '../mutation-type';


let lang = navigator.language;

const state = {
    mainColor: 'white', // 当前主题色
    contentColor: 'red', // 当前显示的红涨绿跌
    lang: lang.indexOf('zh') != -1 || lang.indexOf('cn') != -1?'cn':'en', // 当前语言
    activePage: 'home',
    activeSymbolItem: {
      
    }, // 当前合约
  ...(localStorage.getItem('ehammer.state') ? JSON.parse(localStorage.getItem('ehammer.state')).home : {}),
};

const mutations = {

  [NOW_THEME_COLOR]: (s, mainColor) => {
    s.mainColor = mainColor;
  },
  [NOW_UP_COLOR]: (s, contentColor) => {
    s.contentColor = contentColor;
  },
  [NOW_LANG]: (s, lang) => {
    s.lang = lang;
  },
  [ACTIVE_PAGE]: (s, activePage) => {
    s.activePage = activePage;
  },
  [ACTIVESYMBOL]: (s, activeSymbol) => {
    Object.assign(s.activeSymbolItem, activeSymbol);
  },
};

export default {
  state,
  mutations,
};
